import { connectHook } from '../../connect-hook.js';
import { Monaco } from './monaco.js';
import { useMonaco } from './monaco-hook.js';

export default connectHook(Monaco, useMonaco);
